import React from "react";

import TableCell from "@material-ui/core/TableCell";

import IconButton from "@material-ui/core/IconButton";

import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ConfirmIcon from "@material-ui/icons/Check";
import CancelIcon from "@material-ui/icons/Close";

class Actions extends React.Component {
  onConfirm(e, row) {
    e.stopPropagation();

    const onConfirm = this.props.onConfirm || null;
    if (onConfirm) {
      onConfirm(row);
    }
  }

  onCancel(e, row) {
    e.stopPropagation();

    const onCancel = this.props.onCancel || null;
    if (onCancel) {
      onCancel(row);
    }
  }

  onEdit(e, row) {
    e.stopPropagation();

    const onEdit = this.props.onEdit || null;
    if (onEdit) {
      onEdit(row);
    }
  }

  onDelete(e, row) {
    e.stopPropagation();

    const onDelete = this.props.onDelete || null;
    if (onDelete) {
      onDelete(row);
    }
  }

  renderConfirm(row) {
    const { isEditing, isDeleting, isCreating } = this.props;

    if (isEditing || isDeleting || isCreating) {
      return (
        <IconButton size="small" onClick={(e) => this.onConfirm(e, row)}>
          <ConfirmIcon />
        </IconButton>
      );
    }
  }

  renderCancel(row) {
    const { isEditing, isDeleting, isCreating } = this.props;

    if (isEditing || isDeleting || isCreating) {
      return (
        <IconButton size="small" onClick={(e) => this.onCancel(e, row)}>
          <CancelIcon />
        </IconButton>
      );
    }
  }

  renderEdit(row) {
    const { hasEdit, isEditing, isDeleting } = this.props;

    if (hasEdit && !isEditing && !isDeleting) {
      return (
        <IconButton size="small" onClick={(e) => this.onEdit(e, row)}>
          <EditIcon />
        </IconButton>
      );
    }
  }

  renderDelete(row) {
    const { hasDelete, isEditing, isDeleting } = this.props;

    if (hasDelete && !isEditing && !isDeleting) {
      return (
        <IconButton size="small" onClick={(e) => this.onDelete(e, row)}>
          <DeleteIcon />
        </IconButton>
      );
    }
  }

  render() {
    const { type, row, hasEdit, hasDelete, hasAdd } = this.props;

    const ActionComponent = this.props.actionComponent || null;

    if (!hasEdit && !hasDelete && !hasAdd) {
      return null;
    }

    if (type === "header") {
      return <TableCell padding="default" align="right"></TableCell>;
    }

    return (
      <TableCell padding="default" align="right">
        {this.renderEdit(row)}
        {this.renderDelete(row)}
        {this.renderConfirm(row)}
        {this.renderCancel(row)}
        {ActionComponent && <ActionComponent {...this.props} row={row} />}
      </TableCell>
    );
  }
}

export default Actions;
